import api from "./API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const upload = (file, snCode) => {
  return api.post(`${ApiEndpointConstants.UPLOAD}`, { file, snCode: snCode });
};

// export const uploadVideo = (file, snCode) => {
//   return api.post(
//     `${ApiEndpointConstants.UPLOAD}`,
//     { file, snCode: snCode }
//     // { headers: { "content-type": "multipart/form-data" } }
//   );
// };
